module.exports = __webpack_public_path__ + "media/images/main_bg-f92402dfe57a8ad8243b96b3876e6b0e.gif";